module.exports = __webpack_public_path__ + "img/verona.0fd576f8.png";